export const stepsFromInProduction = [
    'LINK',
    'NOT_STARTED',
    'IN_PROGRESS',
    'REVIEW',
    'FROZEN'
];
